import React, { ReactNode, useMemo } from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import cs from 'classnames';
import { connect } from 'react-redux';

import { useAppDesignScheme } from '../../hooks/useAppDesignScheme';
import { cookieSelectors } from '../../selectors';
import { Utilities } from '../../Utilities';
import { PrivacyTerms } from '../Checkout/components/PrivacyTerms';

type InnerProps = {
  children: ReactNode;
  xsPaddingBottom?: string;
  smPaddingBottom?: string;
};
type Props = InnerProps & MapStateToProps;

// TODO.Refactor in future.More better use 100vh and flex instead calc.
//  I try do it but get a lot of UI issue, so decide use calc instead fix styles (don't know app good yet).
const defaultFooterHeight = '81px';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    // this is "braking" already live embedded sites! they trying to apply their backgrounds
    // backgroundColor: theme.palette.background.default,
    minHeight: `100vh`,
  },
  rootWithFooter: {
    // this is "braking" already live embedded sites! they trying to apply their backgrounds
    // backgroundColor: theme.palette.background.default,

    [theme.breakpoints.up('sm')]: {
      minHeight: (_props: Props) => `calc(100vh - ${defaultFooterHeight})`,
    },
    [theme.breakpoints.only('xs')]: {
      minHeight: (props: Props) =>
        props.xsPaddingBottom
          ? `calc(100vh - (${defaultFooterHeight} + ${props.xsPaddingBottom}))`
          : `calc(100vh - ${defaultFooterHeight})`,
    },
    [theme.breakpoints.only('sm')]: {
      minHeight: (props: Props) =>
        props.smPaddingBottom
          ? `calc(100vh - (${defaultFooterHeight} + ${props.smPaddingBottom}))`
          : `calc(100vh - ${defaultFooterHeight})`,
    },
  },
  emptyContainer: {
    [theme.breakpoints.only('xs')]: {
      paddingBottom: (props: Props) =>
        props.xsPaddingBottom ? props.xsPaddingBottom : '0px',
    },
    [theme.breakpoints.only('sm')]: {
      paddingBottom: (props: Props) =>
        props.smPaddingBottom ? props.smPaddingBottom : '0px',
    },
  },
}));
const MainLayoutComponent = (props: Props) => {
  const { isDark } = useAppDesignScheme();
  const isElixir = useMemo(() => {
    return Utilities.extraOption('data-is-elixir-site');
  }, []);
  const showFooter = !isElixir && props.hasGdprCookieFeatureFlag;

  // hide footer on elixir sites.
  const classes = useStyles(props);
  return (
    <>
      {showFooter ? (
        <>
          <div
            className={cs(classes.rootWithFooter, {
              dark: isDark,
              light: !isDark,
            })}
          >
            {props.children}
          </div>
          <PrivacyTerms />
          <div className={classes.emptyContainer}></div>
        </>
      ) : (
        <div
          className={cs(classes.root, {
            dark: isDark,
            light: !isDark,
          })}
        >
          {props.children}
          <div className={classes.emptyContainer}></div>
        </div>
      )}
    </>
  );
};

type MapStateToProps = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: WebOrder.State) => {
  return {
    hasGdprCookieFeatureFlag: cookieSelectors.hasGdprCookieFeatureFlag(state),
  };
};

export const MainLayout = connect<MapStateToProps, {}, InnerProps>(
  mapStateToProps,
)(MainLayoutComponent);
